import React from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import QRCode from 'qrcode.react'
import { Modal, Button, Grid, Header } from 'semantic-ui-react'

export const buildAdminUploadQrUrl = (projectUrl: string) => {
  const url = new URL(projectUrl)
  url.searchParams.set('utm_source', 'studio')
  url.searchParams.set('utm_medium', 'qr')
  url.searchParams.set('utm_campaign', 'admin_upload')
  return url.toString()
}

const UploadFromPhoneModal = ({ history, projectUrl, setShowModal }: IProps) => {
  // Global
  const projectLinkForQRcode = buildAdminUploadQrUrl(projectUrl)

  return (
    <Modal dimmer="blurring" open>
      <Modal.Header>Test the mobile contributor upload</Modal.Header>
      <Modal.Content>
        <Grid columns={2} centered divided verticalAlign="middle" style={{ height: '100%' }}>
          <Grid.Column>
            <Grid>
              <Grid.Column width={4}></Grid.Column>
              <Grid.Column width={12}>
                <Header as="h3">
                  Scan this QR code to open the public contributor flow on your phone. The link is marked as an
                  administrator-initiated test, but the phone submission remains a contributor upload.
                </Header>
              </Grid.Column>
            </Grid>
          </Grid.Column>
          <Grid.Column textAlign="center">
            <QRCode id="qr-code" value={projectLinkForQRcode} />
          </Grid.Column>
        </Grid>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={() => setShowModal(false)}>Cancel</Button>

        <Button primary onClick={() => history.go(0)}>
          Done
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

interface IProps extends RouteComponentProps<any> {
  projectUrl: string
  setShowModal: (arg: boolean) => void
}

export default withRouter(UploadFromPhoneModal)
